import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import {
  HeaderTitle,
  Table,
  Scroll,
  Message,
  Card,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import { format } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { Spin, Button } from "antd";
import { Container } from "./styles";
import CountUp from "react-countup";
import { MdArrowBack } from "react-icons/md";

dayjs.extend(weekday);
dayjs.extend(localeData);

const Comunicado = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [statement, setStatement] = useState({});
  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadStatement();
  }, []);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadStatement() {
    await api
      .get(`/statement/${id}`)
      .then((response) => {
        setStatement(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 15,
          marginBottom: 20,
        }}
      >
        <Button
          shape="circle"
          icon={<MdArrowBack size={20} />}
          onClick={() => navigate(-1)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
        <h1 style={{ margin: 0 }}>Comunicado e Confirmações</h1>
      </div>
      <Card style={{ marginBottom: 25 }}>
        <p>Total</p>
        <CountUp
          duration={1}
          end={statement.statement_confirms?.length || 0}
          suffix={"/" + users.length}
          separator="."
        />
      </Card>
      {!isLoading && (
        <>
          <h3 style={{ marginTop: 30 }}>{statement.title}</h3>
          <p style={{ color: "#666", fontSize: "14px", marginBottom: 25 }}>
            {statement.description}
          </p>

          {users?.length ? (
            <div className="confirms-list">
              {users.map((user) => {
                const confirmation = statement.statement_confirms.find(
                  (item) => user.id === item.user_id,
                );
                return (
                  <div className="confirm-card" key={user.id}>
                    <div className="main-info">
                      <strong>{user.name}</strong>
                      <span>Franqueado</span>
                    </div>

                    <div className="info-item">
                      <label>Status de Presença</label>
                      <div
                        className={`status-badge ${
                          confirmation ? "confirmado" : "pendente"
                        }`}
                      >
                        {confirmation ? "Confirmado" : "Pendente"}
                      </div>
                    </div>

                    <div className="info-item">
                      <label>Data da Confirmação</label>
                      <span>
                        {confirmation
                          ? format(
                              new Date(confirmation.date),
                              "dd/MM/yyyy HH:mm",
                            )
                          : "---"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <Message>Ocorreu um erro ao carregar franqueados.</Message>
            </div>
          )}
        </>
      )}
      {isLoading && <Spin style={{ marginTop: 50 }} />}
    </Container>
  );
};

export default Comunicado;
